<div *ngIf="productInfo as productInfo else loading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <div class="grid">
        <div class="col-3">
          Начальная дата:
          <p-calendar [(ngModel)]="fromDate"
                      selectionMode="single"
                      [readonlyInput]="true"
                      showButtonBar="true"
                      selectOtherMonths="true"
                      hideOnDateTimeSelect="true"
                      [firstDayOfWeek]="1"
                      [maxDate]="toDate"
                      showWeek="true"
                      showClear="true"
                      dateFormat="dd/mm/yy"
                      inputId="filter-range-from"
                      inputStyleClass="p-dropdown-calendar-style"
                      styleClass="p-column-filter mt-1"
                      panelStyleClass="p-dropdown-filter-style"
                      (onSelect)="onDateRangeChangeFrom( $event)"
                      (onClearClick)="onDateRangeClearFrom( $event)"
                      (onTodayClick)="onTodayClickFrom( $event)">
          </p-calendar>
        </div>
        <div class="col-3">
          Конечная дата:
          <p-calendar [(ngModel)]="toDate"
                      selectionMode="single"
                      [readonlyInput]="true"
                      showButtonBar="true"
                      selectOtherMonths="true"
                      hideOnDateTimeSelect="true"
                      [firstDayOfWeek]="1"
                      [minDate]="fromDate"
                      showWeek="true"
                      showClear="true"
                      dateFormat="dd/mm/yy"
                      inputId="filter-range-to"
                      inputStyleClass="p-dropdown-calendar-style"
                      styleClass="p-column-filter mt-1"
                      panelStyleClass="p-dropdown-filter-style"
                      (onSelect)="onDateRangeChange( $event)"
                      (onClearClick)="onDateRangeClear( $event)"
                      (onTodayClick)="onTodayClick( $event)">
          </p-calendar>
        </div>
        <div class="col-6">
          Документы для поиска товаров:
          <p-multiSelect #dst [options]="docTypes"
                         placeholder="Все документы"
                         (onChange)="onDocTypeChange($event)"
                         (onSelectAllChange)="onAllDocTypeChange($event)"
                         [(ngModel)]="selectedDocTypes"
                         [showToggleAll]="true"
                         [selectAll]="selectAllTypes"
                         styleClass="p-column-filter p-dropdown-filter-style mt-1"
                         optionLabel="DOCNAME1" maxSelectedLabels="1"
                         selectedItemsLabel="{0} документов выбрано"
                         dataKey="DOCTYPEID">
          </p-multiSelect>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="right">
    </ng-template>
  </p-toolbar>

  <app-list-product-array [products]="productInfo" [state]="saveStateKey"></app-list-product-array>

  <!--<p-table #inTransitTable [value]="productInfo"
           [totalRecords]="totalRecords"
           [paginator]="totalRecords > 10"
           [rows]="rows"
           [showCurrentPageReport]="totalRecords > 10"
           [rowsPerPageOptions]="[10,20,50,100]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} товаров"
           selectionMode="single"
           [(selection)]="selectedRow"
           dataKey="PRODID"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
           [resizableColumns]="true"
           columnResizeMode="fit"
           filterDelay="200"
           rowExpandMode="single"
           sortField="DOCEXPDATE">

    <ng-template pTemplate="caption">

    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th pResizableColumn pSortableColumn="PRODCODE" style="width: 15%">Код <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODWAITQNTY" style="width: 8rem">В транзите <p-sortIcon field="PRODWAITQNTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMQTY" style="width: 8rem">Заказано <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCEXPDATE" style="width: 10%">Отгрузка <p-sortIcon field="DOCEXPDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCVALDATE" style="width: 10%">Ожидается <p-sortIcon field="DOCVALDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNAMESTR" style="width: 10%">Документ <p-sortIcon field="DOCNAMESTR"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCDATE" style="width: 10%">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="VENDORNAME" style="width: 10%">Поставщик <p-sortIcon field="VENDORNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10%">Получатель <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 15%">Примечание получателя <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 15%">Примечание поставщика <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>

      <tr>
        <th style="width: 3rem"></th>
        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по коду" class="p-dropdown-filter-style"
                   [(ngModel)]="cf1" (input)="inTransitTable.filter($event.target.value, 'PRODCODE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск..." class="p-dropdown-filter-style"
                   [(ngModel)]="cf2" (input)="inTransitTable.filter($event.target.value, 'PRODWAITQNTY', 'gtOrZero')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="number" placeholder="Поиск..." class="p-dropdown-filter-style"
                   [(ngModel)]="cf3" (input)="inTransitTable.filter($event.target.value, 'DOCITEMQTY', 'gtOrZero')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf4" (input)="inTransitTable.filter($event.target.value, 'DOCVALDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf5" (input)="inTransitTable.filter($event.target.value, 'DOCEXPDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по номеру" class="p-dropdown-filter-style"
                   [(ngModel)]="cf6" (input)="inTransitTable.filter($event.target.value, 'DOCNAMESTR', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf7" (input)="inTransitTable.filter($event.target.value, 'DOCDATE', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf8" (input)="inTransitTable.filter($event.target.value, 'VENDORNAME', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf9" (input)="inTransitTable.filter($event.target.value, 'LOCALCOMP', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf10" (input)="inTransitTable.filter($event.target.value, 'DOCNOTE1', 'contains')">
          </div>
        </th>

        <th pResizableColumn>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск" class="p-dropdown-filter-style"
                   [(ngModel)]="cf11" (input)="inTransitTable.filter($event.target.value, 'DOCNOTE2', 'contains')">
          </div>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-prod let-expanded="expanded">
      <tr [pSelectableRow]="prod">

        <td style="width: 3rem">
          <button type="button" pButton pRipple
                  [pRowToggler]="prod" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"><a [routerLink]="['/edit-product', prod.PRODID]">{{prod.PRODCODE}}</a></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.PRODWAITQNTY | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{prod.DOCITEMQTY | number:'1.0-2' }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCVALDATE  | date:'dd.MM.yyyy'}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCEXPDATE  | date:'dd.MM.yyyy'}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', 10, prod.DOCID]">{{prod.DOCNAMESTR}}</a></td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{prod.DOCDATE  | date:'dd.MM.yyyy'}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.VENDORNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.LOCALCOMP}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.DOCNOTE1}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{prod.DOCNOTE2}}</td>

      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-prod>
      <tr>
        <td colspan="12">
          <div class="p-p-1">
            <app-product-reservation-table [prodId]="prod.PRODID"></app-product-reservation-table>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12">Нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>-->
</div>
<ng-template #loading>
  <p>Информация о товарах загружается...</p>
</ng-template>
